import { jsxs, Fragment } from "react/jsx-runtime";
import { resolveAcceptingSingleKind } from "./utils/resolveAccept.js";
import { disconnectAtBase } from "./utils/disconnectAtBase.js";
import { staticRenderFileKind } from "./utils/staticRenderFileKind.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const isEmptyByUrlField = (urlField) => (accessor) => accessor.getField(urlField).value === null;
class SingleKindFileHandler {
  constructor(kind, isEmpty) {
    this.kind = kind;
    this.isEmpty = isEmpty;
    __publicField(this, "hasBaseEntity");
    this.hasBaseEntity = kind.baseEntity !== void 0;
  }
  get acceptedMimes() {
    return this.kind.acceptMimeTypes;
  }
  async acceptFile(fileOptions) {
    const result = await resolveAcceptingSingleKind(fileOptions, this.kind);
    if (result) {
      return {
        fileKind: this.kind
      };
    }
    return void 0;
  }
  staticRender(environment) {
    const [upload, outsideChildren] = staticRenderFileKind(this.kind, environment);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      upload,
      outsideChildren
    ] });
  }
  resolveEntity(parentEntity) {
    const fileEntity = this.resolveFileEntity(parentEntity);
    const baseEntity = this.kind.baseEntity;
    return {
      parentEntity,
      fileEntity,
      fileKind: this.kind,
      isEmpty: this.isEmpty(fileEntity),
      destroy: baseEntity ? () => {
        disconnectAtBase(baseEntity, parentEntity);
      } : void 0,
      getErrorHolders: () => {
        return [
          parentEntity,
          ...fileEntity !== parentEntity ? [fileEntity] : [],
          ...this.kind.extractors.flatMap((it) => it.getErrorsHolders?.({
            entity: fileEntity,
            environment: fileEntity.environment
          }) ?? [])
        ];
      }
    };
  }
  resolveFileEntity(accessor) {
    return this.kind.baseEntity ? accessor.getEntity(this.kind.baseEntity) : accessor;
  }
}
export {
  SingleKindFileHandler,
  isEmptyByUrlField
};
//# sourceMappingURL=SingleKindFileHandler.js.map
